/**
 * 
 */
class BlockOpener {

	/**
	 * @type HTMLElement
	 */
	element = null;

	/**
	 * @type Boolean
	 */
	isOpen = false;

	/**
	 * @type String
	 */
	stateOpenBodyClassname = 'block-opener-open';

	/**
	 * @type String
	 */
	stateOpenClassname = 'open';

	/**
	 * @type String
	 */
	toggleBtnSelector = '.block-opener-toggle';

	/**
	 * 
	 * @param {HTMLElement} element 
	 */
	constructor( element )
	{
		this.element = element;
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onToggleClick = this.onToggleClick.bind( this );
	}

	/**
	 * 
	 */
	setup()
	{
		this.element.querySelectorAll( this.toggleBtnSelector ).forEach( ( toggleBtnElement ) =>
		{
			toggleBtnElement.addEventListener( 'click', this.onToggleClick );
		} );
	}

	/**
	 * 
	 */
	open()
	{
		this.isOpen = true;
		this.element.classList.add( this.stateOpenClassname );
		/**
		 * @note à vérifier que c'est pas parasitaire à terme
		 */
		document.body.classList.add( this.stateOpenBodyClassname );
	}

	/**
	 * 
	 */
	close()
	{
		this.isOpen = false;
		this.element.classList.remove( this.stateOpenClassname );
		/**
		 * @note à vérifier que c'est pas parasitaire à terme
		 */
		document.body.classList.remove( this.stateOpenBodyClassname );
	}

	/**
	 * 
	 */
	toggleState()
	{
		if ( true === this.isOpen )
		{
			this.close();
		}
		else
		{
			this.open();
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onToggleClick( event )
	{
		this.toggleState();
	}

}

export default BlockOpener;